"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsLibraryLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = __importStar(require("react-dom"));
// providers
const translations_1 = require("../../translations");
const featureFlag_1 = require("../../featureFlag");
const eventBus_1 = require("../../eventBus");
const mobileConnector_1 = require("../../mobileConnector");
const uiInformation_1 = require("../../uiInformation");
// types
const initializer_1 = require("../../initializer");
const provider_1 = require("./provider");
const sharedInfo_1 = require("../../sharedInfo");
const tracker_1 = require("../../tracker");
/**
 * Builds the subapp config object and injects it
 * into window.globals so it can be shared with frame
 *
 * The rendering of the subapp in the DOM is delegated
 * to the DynamicLoader
 */
const componentsLibraryLoader = async ({ id, API, translationsConfig, trackerConfig, mobileConnectorConfig, components, }) => {
    const ComponentWithProviders = ({ history, children }) => ((0, jsx_runtime_1.jsx)(provider_1.ComponentsProviders, { history: history, children: children }));
    const componentsConfig = {};
    Object.keys(components).forEach((key) => {
        const Component = components[key];
        componentsConfig[key] = {
            renderComponent: (domElement) => {
                ReactDOM.render((0, jsx_runtime_1.jsx)(ComponentWithProviders, { history: sharedInfo_1.getSharedInfo.getData().history, children: (0, jsx_runtime_1.jsx)(Component, {}) }), domElement);
            },
        };
    });
    const config = {
        verticalId: id,
        entrypoint: async () => {
            const data = sharedInfo_1.getSharedInfo.getData();
            initializer_1.Session.finishSession();
            initializer_1.Session.initSession(data.sessionData);
            (0, featureFlag_1.setFeatureFlag)(data.featureFlag);
            (0, eventBus_1.setGlobalEventBus)(data.eventBus);
            trackerConfig && (await (0, tracker_1.initAllTrackers)(trackerConfig, API, initializer_1.GenericUSDManager, initializer_1.Authenticator));
            await (0, uiInformation_1.initDeviceUUID)();
            if (await (0, mobileConnector_1.initMobileCommunicator)(initializer_1.Session, mobileConnectorConfig)) {
                await initializer_1.HybridAuthenticator.login();
            }
            try {
                if (translationsConfig) {
                    await (0, translations_1.initTranslationsWithInitialTranslationsAndConfig)(API, translationsConfig, data.translations?.web, data.translations?.config);
                }
            }
            catch (error) {
                console.error(error);
                console.error('Can`t initiate feature flag or translations. Check network');
            }
        },
        componentsConfig,
    };
    window.globals = window.globals || {};
    window.globals[id] = config;
    window.globalPromises?.[id]?.();
};
exports.componentsLibraryLoader = componentsLibraryLoader;
//# sourceMappingURL=index.js.map